module.exports = __webpack_public_path__ + "static/media/punspace.09282027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/punspace.jpg
// module id = 178
// module chunks = 0